/* eslint-disable @typescript-eslint/no-unsafe-argument */
import React, { useEffect, useState } from 'react';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import { useMutation, useQueryClient } from 'react-query';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import StradaSpinner from 'shared-components/components/StradaSpinner';
import { useSelector } from 'react-redux';
import type { RootState } from 'mainStore';
import {
  useLocation,
} from 'react-router-dom';

export default function FinalCostBar(): JSX.Element {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const [isFocused, setIsFocused] = useState(false);
  const [amount, setAmount] = useState(NaN);
  const [updating, setUpdating] = useState<boolean>(false);
  // const sideSheetData = useSelector((state: RootState) => state.workspaces.sideSheetData.sideSheetData);
  const singleSideSheetData = useSelector((state: RootState) => state.workspaces.sideSheetData.singleSideSheetData);
  const setBarData = (): void => {
    if (singleSideSheetData !== null) {
      if (singleSideSheetData.final_cost !== null) {
        setAmount(singleSideSheetData.final_cost);
      } else {
        setAmount(NaN);
      }
    } else {
      setAmount(NaN);
    }
  };
  useEffect(() => {
    setBarData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [singleSideSheetData]);

  const { mutate: updateFinalCost } = useMutation(async () => axios({
    url: `/api/budget-calendar/event/${singleSideSheetData?.id}/`,
    method: 'PATCH',
    data: {
      // eslint-disable-next-line use-isnan
      final_cost: Number.isNaN(Number(amount)) ? 0 : amount,
    },
  }), {
    onSuccess: async (res): Promise<void> => {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      res.data.cost_final !== null && enqueueSnackbar('Final cost updated successfully');
      setUpdating(false);
      if (!location.pathname.includes('dashboard')) {
        await queryClient.invalidateQueries('get-single-sidesheet').then();
        await queryClient.invalidateQueries('sidesheet/get-events').then();
      } else {
        await queryClient.invalidateQueries('get-single-sidesheet').then();
        await queryClient.invalidateQueries('others-events').then();
        await queryClient.invalidateQueries('prioritized-events').then();
        await queryClient.invalidateQueries('user-assigned-events').then();
        await queryClient.invalidateQueries('allevents/get-events').then();
        await queryClient.invalidateQueries('user-created-events').then();
      }
    },
    onError: (): void => {
      setUpdating(false);
      setBarData();
      enqueueSnackbar('Updation failed.', {
        variant: 'error',
        content: (key, message) => (
          <div className='text-white bg-danger ps-4 pe-5 py-3'>
            {message}
          </div>
        ),
      });
    },
  });

  const handleEnterPress = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (e.key === 'Enter') {
      if (singleSideSheetData !== null && singleSideSheetData.final_cost !== amount) {
        if (!(singleSideSheetData.final_cost === null && Number.isNaN(amount))) {
          updateFinalCost();
          setUpdating(true);
        }
      }
    }
  };

  const handleBlur = (): void => {
    setIsFocused(false);
    if (singleSideSheetData !== null && singleSideSheetData.final_cost !== amount) {
      if (!(singleSideSheetData.final_cost === null && Number.isNaN(amount))) {
        updateFinalCost();
        setUpdating(true);
      }
    }
  };

  const handleConditionalText = (): JSX.Element => {
    if (isFocused || !Number.isNaN(amount)) {
      return <>$</>;
    }
    return <HorizontalRuleIcon />;
  };
  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (e.target.value.length < 11) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      setAmount(e.target.valueAsNumber); handleConditionalText();
    }
  };

  return (
    <div className='assignee-sheet-bar'>
      <h6 className='side-sheet-side-label'> Final Cost </h6>
      <div className='assignee-sheet-popover'>
        <div className='popover-btn' aria-hidden='true'>
          { updating && !Number.isNaN(amount) ? <StradaSpinner open={updating} message='Updating' /> : (
            <div className='input-bar'>
              {handleConditionalText()}
              <input
                value={amount}
                onChange={(e): void => { handleValueChange(e); }}
                onFocus={(): void => { setIsFocused(true); }}
                onBlur={(): void => { handleBlur(); }}
                onKeyPress={handleEnterPress}
                type='number'
                min='0'
              />

            </div>
          )}

        </div>
      </div>
    </div>
  );
}
